import * as React from 'react';
import * as styles from './styles.css';

export interface IRealtorsSectionProps {
  arcRef: React.Ref<HTMLDivElement>;
  stickyRef: React.Ref<HTMLDivElement>;
  realtorImages: string;
  onCtaClick: () => void;
}

export const RealtorsSection: React.FC<IRealtorsSectionProps> = ({ arcRef, stickyRef, realtorImages, onCtaClick }) => (
  <section className={styles['realtors-section']} aria-label="Риелторы" ref={stickyRef}>
    <div className={styles['realtors-section__inner']}>
      <div ref={arcRef} className={styles['realtors-arc']} data-arc data-card-srcs={realtorImages} />
      <h1 className={styles['realtors-section__title']}>
        <span>
          Подберём риелтора <br /> под
        </span>{' '}
        <span className={styles['realtors-section__title__blue']}> любую задачу</span>
      </h1>
      <button
        className={`${styles['btn']} ${styles['btn--primary']} ${styles['realtors-section__cta']}`}
        type="button"
        onClick={onCtaClick}
        data-modal-open
      >
        <span className={styles['btn__text']}>Подобрать риелтора</span>
      </button>
    </div>
  </section>
);
